import React, { useState, useEffect, useCallback } from 'react';
import AppRouter from './router/Router';
import { getUserProfile } from './services/api';

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || '' };
  }

  componentDidCatch(error) {
    const msg = String(error?.message || '');
    if (msg.includes('insertBefore') || msg.includes('NotFoundError')) {
      const key = 'station-dom-recover-once';
      if (!sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, '1');
        window.location.reload();
      }
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
          <div className="max-w-md w-full bg-white border border-gray-200 rounded-xl p-5 text-center">
            <h1 className="text-lg font-semibold text-gray-900 mb-2">Se produjo un error de renderizado</h1>
            <p className="text-sm text-gray-600 mb-4">Recarga la pagina para continuar.</p>
            <button onClick={() => window.location.reload()} className="px-4 py-2 bg-emerald-600 text-white rounded-lg text-sm font-medium hover:bg-emerald-700">
              Recargar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function parseToken(token) {
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return { id: payload.id, role: payload.role, id_cliente: payload.id_cliente, nombre_usuario: payload.nombre_usuario || null, cliente_nombre: payload.cliente_nombre || null };
  } catch {
    return null;
  }
}

const App = () => {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [user, setUser] = useState(() => parseToken(localStorage.getItem('token')));

  const fetchAndMergeProfile = useCallback(async (t) => {
    if (!t) return;
    try {
      const res = await getUserProfile(t);
      if (res.cod === 200 && res.data) {
        setUser(prev => ({ ...prev, nombre_usuario: res.data.nombre_usuario || prev.nombre_usuario, cliente_nombre: res.data.cliente_nombre || prev.cliente_nombre }));
      }
    } catch {
      // ignore
    }
  }, []);

  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      setToken(storedToken);
      const parsed = parseToken(storedToken);
      setUser(parsed);
      fetchAndMergeProfile(storedToken);
    }
  }, [fetchAndMergeProfile]);

  const handleLoginSuccess = (token) => {
    localStorage.setItem('token', token);
    setToken(token);
    setUser(parseToken(token));
    fetchAndMergeProfile(token);
  };

  const handleRegisterSuccess = () => {
    // Manejar lógica post registro
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
  };

  return (
    <AppErrorBoundary>
      <AppRouter
        token={token}
        user={user}
        handleLoginSuccess={handleLoginSuccess}
        handleRegisterSuccess={handleRegisterSuccess}
        handleLogout={handleLogout}
      />
    </AppErrorBoundary>
  );
};

export default App;
